import React, { ReactNode } from "react";

import './styles/card-content.scss'

interface Props {
    children: ReactNode;

    title?: string;
    type?: string;
    isPaddingTop?: boolean
}

function CardContent({children, title, type = '', isPaddingTop = false}: Props): ReactNode {
    const classesTop = () => {
        const baseClasses = 'card-content';
        const paddingClass = isPaddingTop ? 'padding-top' : ''

        return `${baseClasses} ${paddingClass} ${type}`
    }

    const cardContentClasses = classesTop()

    return (
        <div className={cardContentClasses}>
            {
                title && <div className="card-content__header">
                    <h6 className={'card-content__title'}>{ title }</h6>
                </div>
            }

            <div className="card-content__container">
                { children }
            </div>
        </div>
    )
}

export default CardContent